import { render, staticRenderFns } from "./BellIcon.vue?vue&type=template&id=40f20ba6&scoped=true&"
import script from "./BellIcon.vue?vue&type=script&lang=js&"
export * from "./BellIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f20ba6",
  null
  
)

export default component.exports